import React, { ReactNode } from 'react';

export enum AlertType {
  Info = 'info',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Neutral = 'neutral',
}

export type AlertHandlerProps = {
  id?: string;
  type?: AlertType;
  text: ReactNode;
  title?: string;
};

type Props = {
  showAlert: (props: AlertHandlerProps) => void;
};

export default React.createContext<Props>({
  showAlert: () => ({}),
});
